module.exports = __webpack_public_path__ + "static/media/ordi002.b2cc82ff.jpg";